/*
 * Copyright (c) 2020. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <https://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { extract } from '@app/core';
import { DashboardComponent } from '@app/dashboard/dashboard/dashboard.component';
import { MenuService } from '@app/core/menu/menu.service';

const routes: Routes = [
  Shell.childRoutes([
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    { path: 'dashboard', component: DashboardComponent, data: { title: extract('Dashboard') } },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [MenuService],
})
export class DashboardRoutingModule {
  constructor(menuService: MenuService) {
    menuService.addItem({
      key: 'dashboard',
      title: 'Dashboard',
      icon: 'fal fa-home',
      path: '/dashboard',
    });
  }
}
